/**
 * VRInteractableComponent - marks an actor as VR-interactable (not grabbable).
 */

import { EngineClass } from '../../systems/ClassRegistry.js';
import { Delegate } from '../../utils/Delegate.js';
import { property } from '../../utils/serialization/decorator.js';
import { XRButton } from '../VRControllerManager.js';

import { VRBaseComponent } from './VRBaseComponent.js';

import type { SceneComponentOptions } from '../../components/SceneComponent.js';

export interface VRInteractableComponentOptions extends SceneComponentOptions {
  vrInteractionRange?: number;
  vrInteractionButton?: XRButton;
}

@EngineClass('VRInteractableComponent')
export class VRInteractableComponent extends VRBaseComponent {


  @property()
  public vrInteractionRange: number = 10;

  @property()
  public vrInteractionButton: XRButton = XRButton.Trigger;


  public override initialize(options?: VRInteractableComponentOptions): void {
    super.initialize(options);
    this.vrInteractionRange = options?.vrInteractionRange ?? this.vrInteractionRange;
    this.vrInteractionButton = options?.vrInteractionButton ?? this.vrInteractionButton;
  }



  public getVRInteractionRange(): number {
    return this.vrInteractionRange;
  }

  public getVRInteractionButton(): XRButton {
    return this.vrInteractionButton;
  }

  public onInteract: Delegate<[hand: 'left' | 'right'], boolean> = new Delegate();
}


